export default {
	rating: 0,
	size: 6,
	space: 2,
	showLabel: false,
};
